module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smallhome"
  }, [_c('div', [_c('el-date-picker', {
    staticStyle: {
      "margin": "10px 5%"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.firstTime_value),
      callback: function($$v) {
        _vm.firstTime_value = $$v
      },
      expression: "firstTime_value"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "echart"
  }, [_c('p', [_vm._v("看诊人数、开方数与预约人数统计图（个）")]), _vm._v(" "), _c('div', {
    ref: "myEchart",
    style: ({
      height: _vm.height,
      width: _vm.width,
      overflow: _vm.overflow
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "pchart"
  }, [_c('p', [_vm._v("资金流动统计（元）"), _c('span', {
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_vm._v("总金额："), _c('span', {
    staticStyle: {
      "color": "#db4958"
    }
  }, [_vm._v(_vm._s(_vm.num) + "元")])])]), _vm._v(" "), _c('div', {
    ref: "myPchart",
    style: ({
      height: _vm.height,
      width: _vm.width,
      overflow: _vm.overflow
    })
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "400px"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7040d3b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/home_content/hello.vue
// module id = 1027
// module chunks = 2